import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import type { ComponentPropsWithoutRef } from 'react';
import { useState } from 'react';

import DesktopTestimonialCards from './DesktopTestimonialCards';
import MobileTestimonialCards from './MobileTestimonialCards';
import type {
  LandingPageTestimonial,
  LandingPageTestimonialsTheme,
} from './types';

export interface LandingPageTestimonialsProps
  extends ComponentPropsWithoutRef<'div'> {
  readonly inverted?: boolean;
  readonly testimonials: LandingPageTestimonial[];
  readonly theme: LandingPageTestimonialsTheme;
}

const LandingPageTestimonials = ({
  inverted = false,
  testimonials,
  theme,
  ...props
}: LandingPageTestimonialsProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const handleActiveIndexChange = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <div {...props}>
      <LayoutGrid>
        <GridItem colStart={{ sm: 'main' }} colEnd={{ sm: 'full', lg: 'main' }}>
          <MobileTestimonialCards
            inverted={inverted}
            testimonials={testimonials}
            theme={theme}
          />
          <DesktopTestimonialCards
            activeIndex={activeIndex}
            inverted={inverted}
            onActiveIndexChange={handleActiveIndexChange}
            testimonials={testimonials}
            theme={theme}
          />
        </GridItem>
      </LayoutGrid>
    </div>
  );
};

export default LandingPageTestimonials;
